import React from 'react'

const Option2 = () => {
  return (
    <div>Option2</div>
  )
}

export default Option2